// extracted by mini-css-extract-plugin
export default {"root":"CheckoutSection_root__u53-Z","mainContainer":"CheckoutSection_mainContainer__WJWVV","paymentContainer":"CheckoutSection_paymentContainer__zAXxP"};